import { ApiRoutes } from "../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../base";
import { ContactFormRequestBody, ContactFormResponse } from "./types";

export class ContactFormAPI extends BaseAPI<
    ContactFormRequestBody,
    ContactFormResponse
> {
    protected route = ApiRoutes.contact.contact;
    protected method = RequestMethod.POST;
}
